import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=40982760&scoped=true"
import script from "./StaffList.vue?vue&type=script&lang=js"
export * from "./StaffList.vue?vue&type=script&lang=js"
import style0 from "./StaffList.vue?vue&type=style&index=0&id=40982760&prod&lang=scss&scoped=true"
import style1 from "./StaffList.vue?vue&type=style&index=1&id=40982760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40982760",
  null
  
)

export default component.exports